import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FxDapHttpClient } from 'app/implementation/shared/fx-http-client';
@Component({
  selector: 'app-operate-info',
  template: `
<div id="operatecontent" class="operatecontent" (click)="operatecloseOpenWin($event)">
	<div id="salesoperate"  class="salesoperate">
	<div class="operate-basic">
          <div class="operate-basiccontent">
               <div class="operate-personimg">
				    <img style="border-radius: 50%;" src="assets/img/home/头像.png">
			   </div>
			   <div style="padding-left: 10px;">
				  <div class="operate-lable">
					{{Traces.cper}}<div class="operate-jianli">建立</div>
				  </div>
				  <div class="operate-jianlidate">
					{{Traces.cdate}}
				  </div>
			   </div>
		  </div>
          <div class="operate-xian"></div>
		  <div class="operate-basiccontent">
				<div style="padding-left: 30px;">
					<div class="operate-lable">
					  <div style="color: #8A95A3;">组织:</div> {{Traces.corg}}
					</div>

					<div class="operate-lable">
						<div style="color: #8A95A3;">部门:</div> {{Traces.cdept}}
					</div>
				</div>
		  </div>
	</div>
	<div class="operate-auite">
		<div class="operate-auitecontent">
			<img class="operate-img" src="assets/img/home/审核.png"><div class="operate-auitelable">审核：</div> <div class="operate-auitevalue">{{Traces.aper}}——{{Traces.adate}}</div>
		</div>
	</div>
	<div class="operate-auitelist">
		<dw-timeline dwMode="custom">
			<dw-timeline-item *ngFor="let obj of Traces.aceList" dwPosition="left">
				<span class="fx_timeline_title">
          {{obj.operation}}
				</span>
			</dw-timeline-item>
		</dw-timeline>
	</div>

  </div>
</div>
  `,
  styles: [`
.operatecontent{
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 1000;
  display: none;
}
.salesoperate{
  position: absolute;
	width: 500px;
  height: 228px;
	background-color: #FFFFFF;
	border-radius: 6px;
  padding-top: 10px;
  box-shadow: 0px 0px 12px 0px rgba(79, 90, 103, 0.2);
}
.operate-basic{
  width: 100%;height: 60px;display: flex;padding: 5px 5px;
}
.operate-basiccontent{
  width: 50%;height: 100%;display: flex; 
}
.operate-personimg{
  width: 40px;height: 40px;margin-left: 5px;margin-top: 5px;
}
.operate-lable{
  color: #111111;font-size: 14px;display: flex;height: 25px;align-items:center;
}
.operate-jianli{
  border-radius: 100px;background: #FFE8C3;display: flex;align-items:center;
	justify-content:center;width: 42px;height: 16px;color: #F0AC40;
}
.operate-jianlidate{
  color: #8A95A3;font-size: 14px;display: flex;height: 25px;align-items:center;
}
.operate-xian{
  width: 1px;height: 26px;border-radius: 2px; opacity: 1;background: #EEEFF1;margin-top: 10px;
}
.operate-auite{
  width: 100%;height: 40px;font-size: 14px;
}
.operate-auitecontent{
  width: 96%;margin-left: 2%;height: 40px;display: flex;padding: 10px 5px;border-bottom:1px solid #EEEFF1;display: flex;align-items:center;
}
.operate-auitelist{
  width: 100%;height: 110px;padding: 20px 10px;overflow-y: auto;
}
.operate-img{
  width: 14px;height: 14px;
}
.operate-auitelable{
  color: #8A95A3;margin-left: 5px;
}
.operate-auitevalue{
  color: #333333;margin-left: 5px;
}
  `],
  encapsulation: ViewEncapsulation.None
})
export class OperateComponent implements OnInit {
  @Input() Traces={
    daecper:"",
    daecper_n1:"",
    daecdate:"",
    daecorg:"",
    daecorg_n1:"",
    daecdept:"",
    daecdept_n1:"",
    daeaper_n1:"",
    daeadate:"",
    aceList:[]
  }; 
  constructor(
    public http: FxDapHttpClient) {
  }

  ngOnInit(): void {
    //获取初始数据
  }
  visible: boolean;

  clickMe(): void {
    this.visible = false;
  }

  change(value: boolean): void {
    console.log(value);
  }

  public showoperateInfor(e,infoOption){
    this.http.post<any>('A/IACommonService/getBasicInformationInfo', { param: infoOption}).subscribe(response => {
       if(response.success){
        var div2 = document.getElementById('operatecontent');
        var div = document.getElementById('salesoperate');
        div2.style.display = 'block';

        var windowHeight = window.innerHeight;
        var windowWidth = window.innerWidth;
        if(e.clientY-50+295>windowHeight){
          div.style.top = (e.clientY-270) + 'px';
        }else{
          div.style.top = (e.clientY-50) + 'px';
        }

        if(e.clientX+500>windowWidth){
          div.style.left = (e.clientX-735) + 'px';
        }else{
          div.style.left = (e.clientX-150) + 'px';
        }

        this.Traces=response.data;
        this.http.post<any>('A/IFxai036Service/getOperationLog', { param: infoOption }).subscribe(result => {
          console.log('更多日志处理', result);
          this.Traces.aceList=result.data;
        });
       }
    });
  }


  
  public operatecloseOpenWin($event){
    var div2 = document.getElementById('operatecontent');
    var div = document.getElementById('salesoperate');
    if (!div.contains($event.target)) {
      div2.style.display = 'none';
    }
  }
}